// global variable
var controllerScrollPanel,
    // fullPageScroll,
    // fullPageScrollReverse,
    headerScroll,
    footerScroll,
    resizeTimer;

$(window).on('load', function(){ 
    // $('body').addClass('is-locked');
    initController();
    handleResize();
});

// Initialize the scrollMagic controller
function initController() {
    // Init new controller
    controllerScrollPanel = new ScrollMagic.Controller();
    
    scrollPanelScenes();

    AOS.init({
        // once: true
        offset: 300,
        duration: 600,
        easing: 'ease-in-out'
    });
}

// If window is resized, destroy controller and reset once resize has stopped
function handleResize() {

    $(window).resize(function() {
        destroyScrollPanels();
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(doneResizing, 500);
    });

    function doneResizing(){
        reInitScrollPanels();
    }
}

// Destroy scroll panels
function destroyScrollPanels() {
    controllerScrollPanel.destroy();
    headerScroll.destroy();

    // desktop only
    if ($(window).width() > 768) {
        footerScroll.destroy();
        // fullPageScroll.destroy();
        // fullPageScrollReverse.destroy();
    }
}
  
// Re-init scroll panels
function reInitScrollPanels() {
    controllerScrollPanel = null;
    headerScroll = null;
    footerScroll = null;
    // fullPageScroll = null;
    // fullPageScrollReverse = null;
    initController();

    // console.log('reinit');
}

var navLink = false;
// Prevent problems with momentum scrolling by pausing for a period of time
function pauseScroll() {
    $('body').addClass('is-locked');
    $('body').on('mousewheel DOMMouseScroll', _.debounce(function(e){
        $('body').removeClass('is-locked');
    }, 100));
}

function scrollPanelScenes() {
    // change header, footer, nav themes based on section
    $('section').each(function (i, elem) {
        var $this = $(elem);
    
        // header change theme
        headerScroll = new ScrollMagic.Scene({
            offset: -180, // Number of pixels user can scroll before panel snaps into place
            triggerElement: elem,
            triggerHook: 0, // Trigger this scene when top of panel hit top window
        })
        .on('start', function(event) {
            // running when scroll forward
            if (event.scrollDirection == 'FORWARD') {
                var theme = $this.data('theme');
    
                $('header div .logo').attr('data-theme', theme);
                $('header div .latest-news-link').attr('data-theme', theme);
                $('header div .mobile-menu').attr('data-theme', theme);
                $('nav').attr('data-theme', theme);
    
                if ($this.hasClass('section-1-3')) {
                    $('header div .latest-news-link').attr('data-theme', 'dark');
                }

            }
    
        })
        .on('leave', function(event) {
            if (event.scrollDirection == 'REVERSE') {
                // check if this section has pin parent
                if  ($this.parent().hasClass('scrollmagic-pin-spacer')) {
                    var $prevThis =  $this.parent().prev();
    
                } else {
                    var $prevThis =  $this.prev();
    
                }
    
                if ($this.parent().hasClass('bg-paper') && $this.index() === 0) {
                    var $prevThis =  $this.parent().prev();
    
                } else {
                    var $prevThis =  $this.prev();
                }

                var theme = $prevThis.data('theme');
                $('header div .logo').attr('data-theme', theme);
                $('header div .latest-news-link').attr('data-theme', theme);
                $('header div .mobile-menu').attr('data-theme', theme);
                $('nav').attr('data-theme', theme);
    
                if ($prevThis.hasClass('section-1-3')) {
                    $('header div .latest-news-link').attr('data-theme', 'dark');
                }
            }
            if (event.scrollDirection == 'FORWARD') {
                /* disable fullpage */
                // if  ($this.next().hasClass('fullpage__section')) {
                //     // pauseScroll();
                // }
            }
        })
        .addTo(controllerScrollPanel);
    
        // desktop only
        if ($(window).width() > 768) {            
            // footer change theme
            footerScroll = new ScrollMagic.Scene({
                offset: 48, // Number of pixels user can scroll before panel snaps into place
                triggerElement: elem,
                triggerHook: 1, // Trigger this scene when top of panel hit top window
            })
            .on('start', function(event) {
                // running when scroll forward
                if (event.scrollDirection == 'FORWARD') {
                    var theme = $this.data('theme');
                    
                    $('footer').attr('data-theme', theme);
        
                    if ($this.hasClass('section-1-3')) {
                        $('footer').attr('data-theme', 'dark');
                    }
                    
                    // remove cover when not in main cover
                    if ($this.hasClass('main-cover')) {
                        $('footer').addClass('on-cover');
                    } else {
                        $('footer').removeClass('on-cover');
                    }
                }
            })
            .on('leave', function(event) {
                if (event.scrollDirection == 'REVERSE') {
                    // check if this section has pin parent
                    if ($this.parent().hasClass('scrollmagic-pin-spacer')) {
                        var $prevThis =  $this.parent().prev();
        
                    } else {
                        var $prevThis =  $this.prev();
        
                    }
        
                    if ($this.parent().hasClass('bg-paper') && $this.index() === 0) {
                        var $prevThis =  $this.parent().prev();
        
                    } else {
                        var $prevThis =  $this.prev();
                    }
        
                    var theme = $prevThis.data('theme');
                    
                    $('footer').attr('data-theme', theme);
        
                    if ($prevThis.hasClass('section-1-3')) {
                        $('footer').attr('data-theme', 'dark');
                    }
        
                    // remove cover when not in main cover
                    if ($prevThis.hasClass('main-cover')) {
                        $('footer').addClass('on-cover');
                    } else {
                        $('footer').removeClass('on-cover');
                    }
                }
            })
            .addTo(controllerScrollPanel);
        }
    });

    // desktop only
    // if ($(window).width() > 768) {
    /* disable fullpage */
    if (false) {
        // Create scenes for fullpage panels

        // $('.fullpage__section').each(function(index, elem) {
        $('.fullpage__section').each(function(index, elem) {
            var $scrollPanel = $(elem);
            
            fullPageScroll = new ScrollMagic.Scene({
                offset: 10, // Number of pixels user can scroll before panel snaps into place
                triggerElement: elem,
                triggerHook: 1, // Trigger this scene when top of panel enters view
            })
            .on('start', function(event) {
                if (event.scrollDirection == 'FORWARD' && !navLink) {
                    // pauseScroll();
                    // manipulation for bottom cover
                    if ($scrollPanel.hasClass('bottom-area')) {
                        var scrollPos = $scrollPanel.offset().top - $scrollPanel.height();
                    } else {
                        var scrollPos = $scrollPanel.offset().top;
                    }
        
                    TweenMax.to(window, 0.5, {scrollTo: {y: scrollPos, autoKill:false}}); 
                }
            })
            .on('enter', pauseScroll)
            .addTo(controllerScrollPanel);
        
            // // Create scenes for fullpage panels, when scrolling reverse
            fullPageScrollReverse = new ScrollMagic.Scene({
                offset: -10, // Number of pixels user can scroll before panel snaps into place
                triggerElement: elem,
                triggerHook: 0,// Trigger this scene when bottom of panel enters view
            })
            .on('start', function(event) {
                if (event.scrollDirection == 'REVERSE' && !navLink) {
                    var scrollPos = $scrollPanel.prev().offset().top + $scrollPanel.prev().innerHeight() - $(window).height();
                }
        
                TweenMax.to(window, 0.5, {scrollTo: {y: scrollPos, autoKill:false}}); 
            })
            .on('leave', pauseScroll)
            .addTo(controllerScrollPanel);
        });
    }
}

// navigation click event
// $('.page-scroll').click(function (e) {
//     navLink = true;
//     var elem = $(this).data('link'),
//         $scrollPanel = $(elem),
//         scrollPos = $scrollPanel.offset().top;
//
//     $('nav').removeClass('mobile-active');
//
//     TweenMax.to(window, 0.5, {scrollTo: {y: scrollPos, autoKill:false}});
//
//     setTimeout(() => {
//         navLink = false;
//     }, 500);
// });

/* show hide*/
$(function(){
    $(window).scroll(function() {
        $('body').addClass('scrolling');
        clearTimeout($.data(this, 'scrollTimer'));
        $.data(this, 'scrollTimer', setTimeout(function() {
            // do something
            $('body').removeClass('scrolling');
        }, 500));
    });
});